var render = function render(){var _vm=this,_c=_vm._self._c;return _c('acclaro-datatable',{attrs:{"grid-title":"My Review Tasks","search-route":"/datatables/my-tasks","search-placeholder":"Filter Review Tasks...","datatable-name":"myreviewtask","grid-classes":[_vm.options.isReviewerOnly ? 'reviewer-only' : ''],"is-reviewer-only":_vm.options.isReviewerOnly,"no-results":'No review tasks found',"options":{
    sortable: [
      'Task', 'Order', 'Review Status', 'Assigned', 'Target',
      'Assigned By', 'Due', 'Completed'
    ],
    perPage: 20
  },"column-templates":_vm.templates},scopedSlots:_vm._u([(!_vm.options.isReviewerOnly)?{key:"buttons",fn:function(){return undefined},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }